export const couponTypes = {
  TIMEBASE: 'timebase',
  ACCOUNT: 'account',
  NO_DISCOUNT: 'no_discount',
  MARKETING: 'marketing',
};

export const couponErrorTypes = {
  INVALID_CODE: 'invalid_code',
  REACH_REDEMPTION: 'reach_redemption',
  DEFAULT: 'default',
};

export const couponFetchStatus = {
  pending: 'PENDING',
  successfully: 'SUCCESSFULLY',
  failure: 'FAILURE',
  idle: 'IDLE',
  init: 'INIT',
};

// Block coupon api is required for special scenarios
export const verifyCouponBlockTypeMap = {
  notBlock: 0,
  blockFreeTrial: 1,
};

export const couponSourceTypeMap = {
  threshold: 'threshold', // threshold coupon
  preload: 'preload', // AT&T coupon
  marketing: 'mt', // marketing
  partnerRefer: 'partner', // partner
  supportCoupon: 'support_coupon', // support coupon
  isSupportCoupon(type) {
    return this.supportCoupon === type;
  }
};

export const couponDiscountTypeMap = {
  percentage: 1, // percentage discount
  fixedAmount: 2, // fixed discount
  thresholdAmount: 5, // threshold fixed discount
};

export const couponDefinitionTypeMap = new Map([
  [1, 'mlm'],
  [2, 'mlm'],
  [3, 'marketing'],
  [4, 'cancellation'],
  [5, 'renew'],
]);

export const errorMessageMap = {
  INVALID_CODE: 'billing.coupon.invalid_code_tips',
  REACH_REDEMPTION: 'billing.coupon.reach_limit',
  DEFAULT: 'billing.coupon.invalid_code_default',
};

export const couponFormModeMap = {
  INIT: 'INIT',
  EDIT: 'EDIT',
};

export const couponValidateStatusTypeMap = {
  SUCCESS: 'Success',
  FAIL: 'Fail',
};

export const cancellationCouponSource = 'cancel';

export const FLOW_TYPE_KEY = 'flowType';
export const PLAN_TYPE_KEY = 'type';

export const subscriptionLevelActionEnum = {
  newSubscription: 1,
  replaceSubscription: 2,
  modifySubscription: 3,
  isNewSubscription(value) {
    return this.newSubscription === value;
  },
  isModifiedSubscription(value) {
    return this.modifySubscription === value;
  },
  isReplaceSubscription(value) {
    return this.replaceSubscription === value;
  },
  isImmediatelyEffectiveSubscription(value) {
    return this.isModifiedSubscription(value) || this.isReplaceSubscription(value);
  }
};

export const marketingCampaignPageQueries = ['cartid', 'coupon', 'persistCoupon', 'jointsale', 'referralCode', 'ftId'];
